// extracted by css-extract-rspack-plugin
module.exports =  {"practice-cards-container":"PracticeCards-m5Ne__practice-cards-container"};